// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"39":"410eabe8","47":"236a586d","276":"79c1f7d9","970":"5ffb5227"}[chunkId] + ".css";
};